import React from 'react';

export default function GlassInputWrapper({ children }) {
  return (
    <div className="glass-input-wrapper">
      {children}
    </div>
  );
}
